/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */
import * as React from "react";
import { Text } from "@fluentui/react";
import styles from "./ViewHeader.module.css";

const ViewHeader = (): JSX.Element => (
    <h1 className={styles.viewHeader}>
        <Text variant="mediumPlus" className="ms-fontColor-white" block>
            Hierarchical Settings Designer
        </Text>
    </h1>
);

export default ViewHeader;
